import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from 'angularfire2/auth';
import { ENV } from '@app/env';

import * as firebase from 'firebase';

@Injectable()
export class HistoryData {

  private ip: string = 'NA';
  private client: string;
  private currentUser: string;

  constructor(
    private afs: AngularFirestore,
    private afAuth: AngularFireAuth,
    private http: HttpClient,
  ) {
    this.getMyIp();
    this.getUser();
    this.client = ENV.client;
  }

  public set(title: string, moduleName: string, action: string, object: any) {
    const obj = {
      ip: this.ip,
      title: title,
      action: action,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      user: this.currentUser,
      obj: object
    };

    return this.afs.collection(this.client).doc('history').collection(moduleName).add(obj);
  }

  /**
   * Set history client data
   *
   * @param title
   * @param moduleName
   * @param action
   * @param object
   */
  public setClient(title: string, moduleName: string, action: string, object: any) {
    const obj = {
      ip: this.ip,
      title: title,
      action: action,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      user: this.currentUser,
      obj: object
    };

    return this.afs.collection(object.id).doc('history').collection(moduleName).add(obj);
  }

  public get(collection: string) {
    return this.afs
      .collection(this.client)
      .doc('history')
      .collection(collection, ref => ref.orderBy('timestamp', 'desc').limit(300))
      .valueChanges();
  }

  public getMyIp() {
    return this.http.get('https://jsonip.com/')
      .subscribe((res: any) => {
        if (res) this.ip = res.ip;
      })
  }

  public getUser() {
    return this.afAuth.authState.subscribe(user => {
      if (user) this.currentUser = user.uid;
    })
  }
}
 // end file


// WEBPACK FOOTER //
// ./src/providers/history.ts